import { config } from "./config";

export const pages = {
  default: {
    footer: true,
    compactFooter: false,
    title: config.siteTitle,
    metaTitle: config.siteTitle,
    siteContent: config.siteDescription,
    siteCover: config.siteCover,
    navPaths: [
      {
        name: "Work on remote",
        link: "work-on-remote",
      },
      {
        name: "Our locations",
        link: "our-locations",
      },
      {
        name: "Feel the vibes",
        link: "feel-the-vibes",
      },
      {
        name: "FAQ",
        link: "faq",
      },
    ],
  },
};
